function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e1) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e1) {
            op = [
                6,
                e1
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import React, { Component, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import RichText from "./BoxDetailsTab/RichText";
import { openModal } from "@common/actions";
import { durationToLocaleString, formatDate, formatDateWithMonthName, replaceWith } from "@common/services/helpers";
import PrismicClient from "@common/utils/prismic";
import { ACCOUNT, MISSING_INFO, PAYMENTS, ROUTE_ORDER, SUBSCRIPTION } from "@config/constants";
import { ROUTE_ORDER_SUBSCRIPTIONS, SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR } from "@config/constants";
import { debounce, first } from "lodash";
var Tooltip = function(param) {
    var subscriptionsPrismic = param.subscriptionsPrismic, userDetails = param.userDetails, i18n = param.i18n, position = param.position, onRenewClick = param.onRenewClick, onSubscribeClick = param.onSubscribeClick, onClose = param.onClose, screenType = param.screenType;
    var _userDetails_subscription__addons, _userDetails_subscription_, _userDetails_subscription;
    var containerRef = useRef(null);
    var _useState = _sliced_to_array(useState(0), 2), offsetWidth = _useState[0], setOffsetWidth = _useState[1];
    var maxPosition = Math.min(position, document.body.clientWidth - offsetWidth / 2 - 8);
    var leftPosition = Math.max(maxPosition, offsetWidth / 2 + 8);
    var hasAddons = (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_subscription = userDetails.subscription) === null || _userDetails_subscription === void 0 ? void 0 : (_userDetails_subscription_ = _userDetails_subscription[0]) === null || _userDetails_subscription_ === void 0 ? void 0 : (_userDetails_subscription__addons = _userDetails_subscription_.addons) === null || _userDetails_subscription__addons === void 0 ? void 0 : _userDetails_subscription__addons.length) > 0;
    var currentActiveSub = first(userDetails === null || userDetails === void 0 ? void 0 : userDetails.subscription);
    var currentActivePlan = first(currentActiveSub === null || currentActiveSub === void 0 ? void 0 : currentActiveSub.plan);
    var periodText = "".concat(formatDate(currentActiveSub === null || currentActiveSub === void 0 ? void 0 : currentActiveSub.currentTermStart), " - ").concat(formatDate(currentActiveSub === null || currentActiveSub === void 0 ? void 0 : currentActiveSub.currentTermEnd));
    var durationText = durationToLocaleString(currentActivePlan, i18n);
    var isDesktop = screenType.web || screenType.tablet;
    useEffect(function() {
        var onTouchStart = function(e1) {
            var withinBoundaries = e1.composedPath().includes(containerRef.current);
            if (!withinBoundaries) {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        };
        document.addEventListener("touchstart", onTouchStart);
        return function() {
            document.removeEventListener("touchstart", onTouchStart);
        };
    }, []);
    var renderPlan = function() {
        var _subscriptionsPrismic_plans_items, _prismicPlan_title;
        var prismicPlan = subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_plans_items = subscriptionsPrismic.plans_items) === null || _subscriptionsPrismic_plans_items === void 0 ? void 0 : _subscriptionsPrismic_plans_items.find(function(plan) {
            var _userDetails_subscription_, _userDetails_subscription;
            return plan.id === (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_subscription = userDetails.subscription) === null || _userDetails_subscription === void 0 ? void 0 : (_userDetails_subscription_ = _userDetails_subscription[0]) === null || _userDetails_subscription_ === void 0 ? void 0 : _userDetails_subscription_.planId);
        });
        return /*#__PURE__*/ _jsx("span", {
            className: "plan-value",
            children: prismicPlan === null || prismicPlan === void 0 ? void 0 : (_prismicPlan_title = prismicPlan.title) === null || _prismicPlan_title === void 0 ? void 0 : _prismicPlan_title.text
        });
    };
    var renderAddons = function() {
        var _userDetails_subscription__addons, _userDetails_subscription_, _userDetails_subscription;
        return userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_subscription = userDetails.subscription) === null || _userDetails_subscription === void 0 ? void 0 : (_userDetails_subscription_ = _userDetails_subscription[0]) === null || _userDetails_subscription_ === void 0 ? void 0 : (_userDetails_subscription__addons = _userDetails_subscription_.addons) === null || _userDetails_subscription__addons === void 0 ? void 0 : _userDetails_subscription__addons.map(function(addon, index) {
            var _subscriptionsPrismic_r_addons_items, _prismicAddon_title;
            var prismicAddon = subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_r_addons_items = subscriptionsPrismic.r_addons_items) === null || _subscriptionsPrismic_r_addons_items === void 0 ? void 0 : _subscriptionsPrismic_r_addons_items.find(function(r_addon) {
                return r_addon.id === addon.id;
            });
            return /*#__PURE__*/ _jsx("span", {
                className: "plan-value",
                children: (prismicAddon === null || prismicAddon === void 0 ? void 0 : (_prismicAddon_title = prismicAddon.title) === null || _prismicAddon_title === void 0 ? void 0 : _prismicAddon_title.text) || (addon === null || addon === void 0 ? void 0 : addon.name)
            });
        });
    };
    var renderDesktopFooterNote = function() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                i18n.subscription.youCanRenewHere,
                " ",
                /*#__PURE__*/ _jsxs("span", {
                    className: "link",
                    onClick: onRenewClick,
                    children: [
                        i18n.subscription.here,
                        "."
                    ]
                }),
                i18n.subscription.orYouCanSubscribeHere,
                " ",
                /*#__PURE__*/ _jsxs("span", {
                    className: "link",
                    onClick: onSubscribeClick,
                    children: [
                        i18n.subscription.fromHere,
                        "."
                    ]
                })
            ]
        });
    };
    var renderMobileFooterNote = function() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "mobile-footernote",
            children: [
                /*#__PURE__*/ _jsxs("span", {
                    children: [
                        i18n.subscription.youCanRenewFromButtonBelow,
                        " ",
                        /*#__PURE__*/ _jsxs("span", {
                            className: "link",
                            onClick: onSubscribeClick,
                            children: [
                                i18n.subscription.fromHere,
                                "."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Button, {
                    classes: {
                        label: "ux-button-label"
                    },
                    onClick: onRenewClick,
                    className: "button raised half-width pointer",
                    children: i18n.account.continueSubscription
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "close-button",
                    onClick: onClose,
                    children: i18n.common.close
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "tooltip-background"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "tooltip-wrapper",
                ref: function(ref) {
                    containerRef.current = ref;
                    setOffsetWidth((ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0);
                },
                style: {
                    left: isDesktop && leftPosition,
                    opacity: offsetWidth ? 1 : 0
                },
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "title",
                        children: i18n.subscription.expiringSubscriptionTitle
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "subtitle",
                        children: i18n.subscription.withDisabledRenewal
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "period-container",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "duration",
                                children: durationText
                            }),
                            /*#__PURE__*/ _jsxs("span", {
                                className: "period",
                                children: [
                                    " \xb7 ",
                                    periodText
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "plan-list",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "plan-item",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "plan-title",
                                        children: i18n.subscription.plan
                                    }),
                                    renderPlan()
                                ]
                            }),
                            hasAddons && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "separator"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "plan-item",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "plan-title",
                                                children: i18n.subscription.addons
                                            }),
                                            renderAddons()
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "tooltip-footernote",
                        children: isDesktop ? renderDesktopFooterNote() : renderMobileFooterNote()
                    })
                ]
            })
        ]
    });
};
var Notifications = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Notifications, Component);
    var _super = _create_super(Notifications);
    function Notifications(props) {
        _class_call_check(this, Notifications);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "onMouseEnter", function(e1) {
            if (_this.props.notifType === "Missing info") return;
            _this.onMouseLeave.cancel();
            var screenType = _this.props.screenType;
            var isMobile = screenType.mobile || screenType.smallMobile;
            !_this.state.showTooltip && !isMobile && _this.setState({
                showTooltip: true,
                tooltipPosition: e1.clientX
            });
        });
        _define_property(_assert_this_initialized(_this), "onMouseLeave", debounce(function(e1) {
            _this.setState({
                showTooltip: false,
                tooltipPosition: 0
            });
        }, 200));
        _define_property(_assert_this_initialized(_this), "onButtonClick", function(e1) {
            var _this_props = _this.props, screenType = _this_props.screenType, _$openModal = _this_props.openModal, notifType = _this_props.notifType, history = _this_props.history;
            var isMobile = screenType.mobile || screenType.smallMobile;
            if (notifType === "Missing info") {
                _$openModal(MISSING_INFO, {
                    forceShow: true
                });
                return;
            }
            if (isMobile) {
                _this.setState({
                    showTooltip: true,
                    tooltipPosition: e1.clientX
                });
            } else {
                _this.onClose();
                history.push("order");
            }
        });
        _define_property(_assert_this_initialized(_this), "onRenewClick", function() {
            _this.setState({
                showTooltip: false,
                tooltipPosition: 0
            });
            _this.props.openModal(ACCOUNT, {
                initialComponent: SUBSCRIPTION
            });
        });
        _define_property(_assert_this_initialized(_this), "onSubscribeClick", function() {
            _this.setState({
                showTooltip: false,
                tooltipPosition: 0
            });
            _this.props.history.push(ROUTE_ORDER);
        });
        _define_property(_assert_this_initialized(_this), "onClose", function() {
            _this.setState({
                closed: true
            });
            sessionStorage.setItem("missing-info-notification-postponed", "true");
            var rootElement = document.getElementsByClassName("router-container")[0];
            if (rootElement) {
                var _this_props_onClose, _this_props;
                (_this_props_onClose = (_this_props = _this.props).onClose) === null || _this_props_onClose === void 0 ? void 0 : _this_props_onClose.call(_this_props, true);
                rootElement.style.removeProperty("height");
                var currentStyle = rootElement.getAttribute("style") || "";
                rootElement.setAttribute("style", "".concat(currentStyle, " height: calc(100vh - 60px) !important;"));
            }
        });
        _this.state = {
            showTooltip: false,
            tooltipPosition: 0,
            prismicData: null,
            closed: false
        };
        _this.onClose = _this.onClose.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(Notifications, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_props_onClose, _this_props, prismicData, e1, _this_props_i18n_errors_prismic, localizedErrorMessage;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!PrismicClient.hasPrismic()) return [
                                    2
                                ];
                                (_this_props_onClose = (_this_props = _this.props).onClose) === null || _this_props_onClose === void 0 ? void 0 : _this_props_onClose.call(_this_props, false);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    PrismicClient.getNotifications()
                                ];
                            case 2:
                                prismicData = _state.sent();
                                _this.setState({
                                    prismicData: prismicData
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e1 = _state.sent();
                                localizedErrorMessage = ((_this_props_i18n_errors_prismic = _this.props.i18n.errors.prismic) === null || _this_props_i18n_errors_prismic === void 0 ? void 0 : _this_props_i18n_errors_prismic[e.message]) || _this.props.i18n.errors.generic;
                                _this.props.enqueueSnackbar(localizedErrorMessage, {
                                    variant: SNACKBAR_VARIANT_ERROR,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var rootElement = document.getElementsByClassName("router-container")[0];
                if (rootElement) {
                    rootElement.style.removeProperty("height");
                    var currentStyle = rootElement.getAttribute("style") || "";
                    rootElement.setAttribute("style", "".concat(currentStyle, " height: calc(100vh - 60px) !important;"));
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_state_prismicData_items, _this_state_prismicData, _this_state_prismicData_items1, _this_state_prismicData1, _icon_dimensions, _icon_dimensions1;
                if (this.state.closed) return null;
                var _this_props = this.props, i18n = _this_props.i18n, userDetails = _this_props.userDetails, screenType = _this_props.screenType, notifType = _this_props.notifType, prismic = _this_props.prismic, history = _this_props.history;
                var cf_provider = userDetails.cf_provider;
                // const cf_provider = "cf_provider";
                var isMobile = screenType.mobile || screenType.smallMobile;
                if (!this.state.prismicData) return null;
                if (notifType === "Shopping cart" && history.location.pathname === ROUTE_ORDER_SUBSCRIPTIONS) {
                    return null;
                }
                if (notifType === "Missing info" && sessionStorage.getItem("missing-info-notification-postponed")) {
                    return null;
                }
                var _this_state_prismicData_items_find;
                var notificationData = (_this_state_prismicData_items_find = (_this_state_prismicData = this.state.prismicData) === null || _this_state_prismicData === void 0 ? void 0 : (_this_state_prismicData_items = _this_state_prismicData.items) === null || _this_state_prismicData_items === void 0 ? void 0 : _this_state_prismicData_items.find(function(i) {
                    return i.provider === cf_provider && i.button_functionality === notifType;
                })) !== null && _this_state_prismicData_items_find !== void 0 ? _this_state_prismicData_items_find : (_this_state_prismicData1 = this.state.prismicData) === null || _this_state_prismicData1 === void 0 ? void 0 : (_this_state_prismicData_items1 = _this_state_prismicData1.items) === null || _this_state_prismicData_items1 === void 0 ? void 0 : _this_state_prismicData_items1.find(function(i) {
                    return !i.provider && i.button_functionality === notifType;
                });
                if (!notificationData) return null;
                var background = notificationData.background, color_1 = notificationData.color_1, color_2 = notificationData.color_2, color_1_opacity = notificationData.color_1_opacity, color_2_opacity = notificationData.color_2_opacity, icon = notificationData.icon, info_icon = notificationData.info_icon, info_text = notificationData.info_text, info_text_mobile = notificationData.info_text_mobile, button_text = notificationData.button_text;
                var convertHexToRgba = function(hex, opacity) {
                    var cleanHex = hex.replace("#", "");
                    var r = Number.parseInt(cleanHex.substring(0, 2), 16);
                    var g = Number.parseInt(cleanHex.substring(2, 4), 16);
                    var b = Number.parseInt(cleanHex.substring(4, 6), 16);
                    var alpha = opacity / 100;
                    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
                };
                var color1Rgba = convertHexToRgba(color_1, color_1_opacity);
                var color2Rgba = convertHexToRgba(color_2, color_2_opacity);
                var subscription = userDetails.subscription ? userDetails.subscription[0] : null;
                if (subscription) {
                    var subscriptionTermEnd = formatDateWithMonthName(subscription === null || subscription === void 0 ? void 0 : subscription.currentTermEnd, i18n.months);
                    info_text[0].text = replaceWith(info_text[0].text, subscriptionTermEnd);
                    info_text_mobile[0].text = replaceWith(info_text_mobile[0].text, subscriptionTermEnd);
                    if (!isEmpty(info_text[0].spans)) {
                        info_text[0].spans[0].end = info_text[0].spans[0].start + subscriptionTermEnd.length + 1;
                    }
                    if (!isEmpty(info_text_mobile[0].spans)) {
                        info_text_mobile[0].spans[0].end = info_text_mobile[0].spans[0].start + subscriptionTermEnd.length;
                    }
                }
                var rootElement = document.getElementsByClassName("router-container")[0];
                if (rootElement) {
                    rootElement.style.removeProperty("height");
                    var currentStyle = rootElement.getAttribute("style") || "";
                    rootElement.setAttribute("style", "".concat(currentStyle, " height: calc(100vh - 121px) !important;"));
                }
                return /*#__PURE__*/ _jsxs("div", {
                    className: "notifications-wrapper",
                    style: {
                        display: "flex",
                        alignItems: "center",
                        padding: "12px 20px",
                        background: (background === null || background === void 0 ? void 0 : background.url) ? "linear-gradient(to right, ".concat(color1Rgba, ", ").concat(color2Rgba, "), url(").concat(background.url, ")") : "linear-gradient(to right, ".concat(color1Rgba, ", ").concat(color2Rgba, ")"),
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        minHeight: "61px",
                        gap: "16px"
                    },
                    onMouseEnter: this.onMouseEnter,
                    onMouseLeave: this.onMouseLeave,
                    children: [
                        this.state.showTooltip && /*#__PURE__*/ _jsx(Tooltip, {
                            i18n: i18n,
                            userDetails: userDetails,
                            position: this.state.tooltipPosition,
                            subscriptionsPrismic: prismic === null || prismic === void 0 ? void 0 : prismic.subscriptions,
                            screenType: screenType,
                            onRenewClick: this.onRenewClick,
                            onSubscribeClick: this.onSubscribeClick,
                            onClose: this.onMouseLeave
                        }),
                        info_icon && (icon === null || icon === void 0 ? void 0 : icon.url) && /*#__PURE__*/ _jsx("img", {
                            src: icon.url,
                            alt: "icon",
                            style: {
                                width: ((_icon_dimensions = icon.dimensions) === null || _icon_dimensions === void 0 ? void 0 : _icon_dimensions.width) ? "".concat(icon.dimensions.width, "px") : "24px",
                                height: ((_icon_dimensions1 = icon.dimensions) === null || _icon_dimensions1 === void 0 ? void 0 : _icon_dimensions1.height) ? "".concat(icon.dimensions.height, "px") : "24px",
                                flexShrink: 0
                            }
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "message-content",
                            children: isMobile && (info_text_mobile === null || info_text_mobile === void 0 ? void 0 : info_text_mobile[0]) ? /*#__PURE__*/ _jsx(RichText, _object_spread({}, info_text_mobile[0])) : (info_text === null || info_text === void 0 ? void 0 : info_text[0]) ? /*#__PURE__*/ _jsx(RichText, _object_spread({}, info_text[0])) : "Notification"
                        }),
                        button_text && /*#__PURE__*/ _jsx(Button, {
                            classes: {
                                label: "ux-button-label"
                            },
                            onClick: this.onButtonClick,
                            className: "button raised half-width pointer button-no-wrap",
                            style: {
                                marginLeft: "auto",
                                flexShrink: 0,
                                backgroundColor: "#FFFFFF",
                                color: "#333333"
                            },
                            children: button_text
                        }),
                        notifType === "Missing info" && /*#__PURE__*/ _jsx("span", {
                            className: "icon icon-clear pointer small",
                            onClick: this.onClose,
                            onKeyDown: this.onClose
                        })
                    ]
                });
            }
        }
    ]);
    return Notifications;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, userDetails = param.userDetails, screenType = param.screenType;
    return {
        i18n: i18n,
        userDetails: userDetails,
        screenType: screenType
    };
};
export default withRouter(connect(mapStateToProps, {
    openModal: openModal
})(Notifications));
